import React from 'react'
import BadgeUI from '../../../widgets/output/BadgeUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import ButtonLinkUI from '../../../widgets/action/ButtonLinkUI'

const DirectorListUI = ({ context, messageList, directorList,
  searchFilter, onRefreshClick, onDismissClick, onSearchFilterChange,
  onUpdateDueDateClick, onSendReminderClick, onAllocateClick
}) =>
  <div className='c_directors'>

    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          messageList={messageList}
          onRefreshClick={onRefreshClick}
        />
      }
      right={
        <span />
      }
    />
    <div>
      {
        directorList.map((director, i) =>
          <DirectorRowUI key={i} context={context} messageList={messageList} director={director}
          />
        )
      }
    </div>
  </div>

const DirectorRowUI = ({ context, director, messageList }) =>
  <div className='g_m_top_100'>
    <div className='g_flex_h'>
      <span>{director.directorName}</span>
      {
        director.panVerified && director.aadhaarVerified &&
        <BadgeUI messageList={messageList} labelKey='c_status_done' />
      }
      {
        (!director.panVerified || !director.aadhaarVerified) &&
        <ButtonLinkUI messageList={messageList} labelKey='c_verify'
          to={`/kyc/individualPAN/${director.companyDirectorId}`} transparent={true} />
       }
    </div>
  </div>

const ActionLeftUI = ({ context, messageList, onRefreshClick
}) =>
  <div className='g_flex_h'>
    <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' />
  </div>

export default DirectorListUI
